export const isLandscape = (screenOrientation: string): boolean => {
  return (
    screenOrientation === 'LANDSCAPE-LEFT' ||
    screenOrientation === 'LANDSCAPE-RIGHT'
  );
};
